import React from 'react';
import ReactDOM from 'react-dom/client';
import './style.css';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import {Provider} from "react-redux";
import store from "./store"

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
	// non utilizzo StrictMode per evitare che ci sia un doppio render dei component
	// <React.StrictMode>
    <Provider store={store}>
        <App />
    </Provider>
	// </React.StrictMode>
);
